import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { LoadingBarState } from '@ngx-loading-bar/core/loading-bar.state';
import { catchError, finalize, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import * as UserAccountsActions from '../actions/user-accounts.action';
import { ClientManagementService } from '../../../management/services';
import { UserAccount } from '../../../management/models';
import * as Reducers from '../reducers';


@Injectable()
export class UserAccountsEffects {
    public getCurrentClientUserAccounts$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UserAccountsActions.getCurrentClientUserAccounts),
            withLatestFrom(this.store$.select(Reducers.getUserAccounts)),
            switchMap(() => {
                this.loader.start();
                return this.clientManagementService.getClientUsers().pipe(
                    map((data: UserAccount[]) => {
                            this.loader.complete();
                            return UserAccountsActions.getCurrentClientUserAccountsSuccess({data});
                        }
                    ),
                    catchError((error: any) =>
                        of(UserAccountsActions.getCurrentClientUserAccountsFailure({ error }))
                    ),
                    finalize(() => {
                        this.loader.complete();
                    })
                );
            })
        )
    );


  private loader!: LoadingBarState;

  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private loadingBar: LoadingBarService,
    private clientManagementService: ClientManagementService
  ) {
    this.loader = this.loadingBar.useRef('main');
  }
}
